module.exports = __webpack_public_path__ + "img/phone.8bf2720c.png";